// extracted by mini-css-extract-plugin
export default {"title":"CallSentiments_title__i2g6t","percentage":"CallSentiments_percentage__se6BU","label":"CallSentiments_label__EA1RR","description":"CallSentiments_description__ihUbb"};